import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiBasketTemp from "../../../core/api/api.basketTemp";
import SwalMessage from "../_Components/SwalMessage";
import { useNavigate } from "react-router-dom";


export const NewBasketModal = () => {
  let navigate = useNavigate();
  let back = (e) => {
    e.stopPropagation();
    navigate(-1);
  };
  const { handleSubmit, control, formState: { errors, isSubmitting } } = useForm({
    defaultValues: { roleList: [], id: "" }
  });


  // useEffect(() => {
  //     (async () => {
  //         try {
  //             if (!_.isEmpty(location.state) && location.state?.newBasket) {

  //                 // دریافت اطلاعات کاربر جهت ویرایش
  //             
  //                 // if (response.succeeded == true) {
  //                 //     setUserTransaction(response.data);
  //                 //setValue("roleList", response.data.roleList);
  //                 //}
  //             }
  //         } catch (error) {
  //         }
  //     })();

  //     return () => { };
  // }, []);

  const onSubmit =
    async (data) => {
      try {

        let response = await ApiBasketTemp.createBasketTemp(data);

        if (response.succeeded) {
          navigate("/ViewNewBasketContents/" + response.data.id);
        }

        SwalMessage({ title: response.message + (response.succeeded == true && "سبد با موفقیت ایجاد شد"), iSsuccess: response.succeeded });
      } catch (error) {
      }
    }

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size='md' show={true} >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>ایجاد سبد </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <Col xs='12'>
              <Controller
                name="firstName"
                control={control}
                rules={{}}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام "
                    margin="normal"
                    variant="outlined"
                    size='small'
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {/* {errors.firstName && <span>لطفا نام لاتین را وارد نمایید</span>} */}
            </Col>
            <Col xs='12'>
              <Controller
                name="lastName"
                control={control}
                rules={{}}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام خان.ادگی"
                    margin="normal"
                    variant="outlined"
                    size='small'
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {/* {errors.firstName && <span>لطفا نام لاتین را وارد نمایید</span>} */}
            </Col>
            <Col xs='12'>
              <Controller
                name="phoneNumber"
                control={control}
                rules={{ required: true, }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="شماره تماس"
                    margin="normal"
                    variant="outlined"
                    size='small'
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {errors.firstName && <span>لطفا شماره موبایل را وارد نمایید</span>}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon />  ایجاد و یا دریافت آخرین سبد فعال
                        </Button>
            <Button variant="danger" onClick={back}>
              <CloseIcon />  بستن
                        </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
